module.exports = __webpack_public_path__ + "static/media/deteccao_de_movimento.79779855.png";